import React from 'react';
import GlobalStyles from '@mui/material/GlobalStyles';

export const globalStyles = (
  <GlobalStyles
    styles={{
      html: { height: '100%' },
      body: { height: '100%' },
      ul: { listStyle: 'none', margin: 0, padding: 0 },
      ol: { listStyle: 'none', margin: 0, padding: 0 },
    }}
  />
);
